
























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import DeployDialog from './DeployDialog.vue';
import {
  Deployment,
  Service,
  CreateDeploymentDTO,
  BulkUpgradeDTO,
  Response
} from '@/types';
import Constants from '@/constants';
import { DEPLOYMENT_UPDATE_SELECTED_DEPLOYMENT } from '@/store/mutypes';

@Component({
  name: 'bulk-upgrade'
})
export default class BulkUpgrade extends Vue {
  @Prop({ required: true, type: Object })
  service!: Service;

  private showDialog: boolean = false;
  private versionId: string = '';
  private environment: string = '';
  private isLoading: boolean = false;

  @State(s => s.ServiceMod.services)
  services!: Service[];

  @Getter
  getServiceById!: (id: string) => Service;

  @Action
  bulkUpgrade!: (dto: BulkUpgradeDTO) => Response;

  openDialog() {
    this.versionId = '';
    this.environment = '';
    this.showDialog = true;
  }

  validate() {
    let isValid = true;
    if (this.versionId === '') {
      this.$notify.error('Please Select a version');
      isValid = false;
    }
    if (this.environment === '') {
      this.$notify.error('Please Select a environment');
      isValid = false;
    }
    return isValid;
  }

  async onUpgrade() {
    if (this.validate()) {
      this.isLoading = true;
      try {
        await this.bulkUpgrade({
          versionId: this.versionId,
          environment: this.environment
        });
        this.$notify.success('Successfully upgraded all selected instances.');
        this.showDialog = false;
      } catch (e) {
        this.$notify.error('Fail to upgrade.');
      }
      this.isLoading = false;
    }
  }
}
